const APIS = {
    GET_USER: window['runConfig'].REACT_APP_BASE_URL + 'user/account',
    USER_PASSWORD: window['runConfig'].REACT_APP_BASE_URL + 'user/password',
    USER_ATTRIBUTE: window['runConfig'].REACT_APP_BASE_URL + 'user/attribute',
    GET_LOGIN_USER: window['runConfig'].REACT_APP_BASE_URL + 'user',
    TABLE_DATA: window['runConfig'].REACT_APP_BASE_URL + 'charge/filelog?accountid=',
    SEARCH_DATA: window['runConfig'].REACT_APP_BASE_URL + 'charge/fetchprocessedbysource?corpaccountid=',
    REFRESH_DATA: window['runConfig'].REACT_APP_BASE_URL + 'charge/document?filelogid=',
    UPLOAD_CHARGE: window['runConfig'].REACT_APP_BASE_URL + 'charge/document',
    PATIENT_DATA: window['runConfig'].REACT_APP_BASE_URL + 'charge/filelog/',
    REPROCESS_DATA:window['runConfig'].REACT_APP_BASE_URL +'charge/reprocesschargemessages',
    INBOX_PAGE_LABEL: window['runConfig'].REACT_APP_BASE_URL + 'sma/label/count?userid=',
    FAX_DOCUMENT_LIST: window['runConfig'].REACT_APP_BASE_URL + 'sma/document?filter=',
    INBOX_GET_DOC_ACTION: window['runConfig'].REACT_APP_BASE_URL + 'sma/document/action?accountid=',
    SENT_GET_DOC_ACTION: window['runConfig'].REACT_APP_BASE_URL + 'sma/document/sentitems/status?accountid=',
    IN_PROGRESS_ACTION: window['runConfig'].REACT_APP_BASE_URL + 'sma/document/action',
    SAVE_UPDATE_DIRECTORY: window['runConfig'].REACT_APP_BASE_URL + 'sma/directory',
    INBOX_GET_DIRECTORY: window['runConfig'].REACT_APP_BASE_URL + 'sma/directory?accountid=',
    SAVE_NAME_DOB: window['runConfig'].REACT_APP_BASE_URL + 'sma/document/',
    SEND_MSG_DOC: window['runConfig'].REACT_APP_BASE_URL + 'sma/document/send?type=',
    RESEND_MSG: window['runConfig'].REACT_APP_BASE_URL + 'sma/document/resend?accountid=',
    SENT_ITEMS: window['runConfig'].REACT_APP_BASE_URL + 'sma/document/sentitems?accountid=',
    VIEW_TEXT_PDF: window['runConfig'].REACT_APP_BASE_URL + 'sma/document/',
    SEND_FAX_PREVIEW: window['runConfig'].REACT_APP_BASE_URL + 'sma/document/preview?accountid=',
    LINK_DOCUMENT_LABEL: window['runConfig'].REACT_APP_BASE_URL + 'sma/document/label',
    SETTING_APPS: window['runConfig'].REACT_APP_BASE_URL + 'settings/apps?accountid=',
    LOOKUP_PATIENT: window['runConfig'].REACT_APP_BASE_URL + "fhir/api/patient/", 
    LOOKUP_CARRIER: window['runConfig'].REACT_APP_BASE_URL + "fhir/api/carrier/", 
    UPLOAD_EHR_DOC: window['runConfig'].REACT_APP_BASE_URL + "fhir/api/EHRDocument/upload",
    CREATE_LABEL: window['runConfig'].REACT_APP_BASE_URL + 'sma/label/rule',
    SET_DOC_PRIORITY: window['runConfig'].REACT_APP_BASE_URL + 'sma/document/priority',
    SET_DOC_READ_STATUS: window['runConfig'].REACT_APP_BASE_URL + 'sma/document/read',
    GET_ALL_PATIENT:window['runConfig'].REACT_APP_BASE_URL+'labportal/patient',
    SEARCH_PATIENT:window['runConfig'].REACT_APP_BASE_URL+'labportal/patient',
    POST_LINKED_PATIENT:window['runConfig'].REACT_APP_BASE_URL+"labportal/linkuserpatient",
    GET_ALL_USERS: window['runConfig'].REACT_APP_BASE_URL + 'user/getall?accountid=',
    GET_ALL_LABELS: window['runConfig'].REACT_APP_BASE_URL + 'sma/label?accountid=',
    GET_USER_INFO: window['runConfig'].REACT_APP_BASE_URL + 'user/',
    CREATE_DRAFT: window['runConfig'].REACT_APP_BASE_URL + "sma/document/draft?userid=",
    FETCH_DRAFT: window['runConfig'].REACT_APP_BASE_URL + "sma/document/draft?accountid=",
    GET_LABEL_INFO: window['runConfig'].REACT_APP_BASE_URL + 'sma/label/',
    SMART_REFFERAL_DRAFT: window['runConfig'].REACT_APP_BASE_URL + 'sma/smartreferal/draft?accountid=',
    SMART_REFFERAL_SEND: window['runConfig'].REACT_APP_BASE_URL + 'sma/smartreferal?accountid=',
    VERIFY_SENDER: window['runConfig'].REACT_APP_BASE_URL + 'sma/smartreferal/verifysender?directoryid=',
    GET_HEADER_ANALYTICS: window['runConfig'].REACT_APP_BASE_URL + 'sma/dashboard/stats?accountid=',
    GET_TOPTEN_ANALYTICS: window['runConfig'].REACT_APP_BASE_URL + 'sma/dashboard/toptens?accountid=',
    GET_CONVERSATION: window['runConfig'].REACT_APP_BASE_URL + 'sma/document/conversation?documentid=',
    GET_CORP_ACCOUNTS: window['runConfig'].REACT_APP_BASE_URL + 'sma/admin/corpaccount',
    GET_BRANDS: window['runConfig'].REACT_APP_BASE_URL + 'user/brand',
    GET_ACCOUNT_APPS: window['runConfig'].REACT_APP_BASE_URL + 'user/account/apps?accountid=',
    GET_ACCOUNTS_REPORTING:window['runConfig'].REACT_APP_BASE_URL + 'settings/apps/accounts',
    // GET_LABPORTAL_ORDERS: 'https://dev.api.falkondata.com/api/labportal/orders?userid=',
    // GET_SEARCH_LABPORTAL:'https://dev.api.falkondata.com/api/labportal/search',
    GET_LABPORTAL_ORDERS: window['runConfig'].REACT_APP_BASE_URL + 'labportal/orders?userid=',
    GET_SEARCH_LABPORTAL:window['runConfig'].REACT_APP_BASE_URL + 'labportal/search',
    GET_LABPORTAL_ORDER_RESULTS: window['runConfig'].REACT_APP_BASE_URL + 'labportal/orders/results?laborderid=',
    GET_LABPORTAL_ORDER_REPORT: window['runConfig'].REACT_APP_BASE_URL + 'labportal/orders/results/',
    GET_LABPORTAL_PATIENT_ORDER: window['runConfig'].REACT_APP_BASE_URL + 'labportal/patient/orders?patientid=',
    GET_APPS: window['runConfig'].REACT_APP_BASE_URL + 'user/apps',
    GET_ACCOUNTS: window['runConfig'].REACT_APP_BASE_URL + 'sma/admin/account?corpaccountid=',
    CREATE_ACCOUNTS: window['runConfig'].REACT_APP_BASE_URL + 'sma/admin/account',
    EDIT_ODBC: window['runConfig'].REACT_APP_BASE_URL + 'rpt/dashboard/odbc',
    GET_ACCOUNT: window['runConfig'].REACT_APP_BASE_URL + 'sma/admin/account/',
    UPDATE_ACCOUNTS: window['runConfig'].REACT_APP_BASE_URL + 'sma/admin/account',
    //CREATE_CORP_ACCOUNTS: window['runConfig'].REACT_APP_BASE_URL + 'sma/admin/corpaccount',
    REPROCESS_RULES: window['runConfig'].REACT_APP_BASE_URL + 'sma/reprocessrules',
    GET_REPORT_NAMES: window['runConfig'].REACT_APP_BASE_URL + 'rpt',
    REFERRAL_PATIENT: window['runConfig'].REACT_APP_BASE_URL + 'fhir/api/patient/',
    EXPORT_DATA:window['runConfig'].REACT_APP_BASE_URL + 'file?accountid=',
    REPORTING_TYPE:window['runConfig'].REACT_APP_BASE_URL + 'rpt/dashboard/',
    COMPLIANCE_REPORT:window['runConfig'].REACT_APP_BASE_URL + 'labportal/compliance_report',
    COMPLIANCE_REPORT_PDF:window['runConfig'].REACT_APP_BASE_URL + 'labportal/compliance_report/',
    GET_USERS_CASEWORKER:window['runConfig'].REACT_APP_BASE_URL+'labportal/users'
}

export {
    APIS
}

//process.env